import i18n from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import TagBadge from "../../../../../core/et3-shared-components/TagBadge";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";

const ActiveFeatureSets = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const advancedStore = getUserAdvancedStore();
  const {
    isPaidAlkhattabat,
    isSubscribedAlkhattabat,
    isPaidVIP,
    isSubscribedVIP,
    isPaidPlus,
    isSubscribedPlus,
    isPaidBoost,
    isSubscribedBoost,
    isPaidRewind,
    isSubscribedRewind,
    isPaidSilver,
    isSubscribedSilver,
    isPaidGold,
    isSubscribedGold,
    isPaidPlatinum,
    isSubscribedPlatinum,
    isPaidPower,
    isSubscribedPower
  } = advancedStore.getUserSubscriptionStatus.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={36}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{ width: "100%" }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={350}
        height={36}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          text={i18n.get("ACTIVE_FEATURE_SETS")}
          fontFamily="MEDIUM"
          fontSize={14}
          color={colors.all.black}
          isSpan={true}
          style={{}}
        />
      </ET3Div>

      <TagBadge
        tag={i18n.get("SILVER_TAG")}
        tagColor={isSubscribedSilver ? colors.all.plumBrown : colors.all.gray}
        isPaid={isPaidSilver}
        tagWidth={70}
      />
      <Et3Margin top={0} bottom={0} left={0} right={5} />
      <TagBadge
        tag={i18n.get("GOLD_TAG")}
        tagColor={isSubscribedGold ? colors.all.bronzedGold : colors.all.gray}
        isPaid={isPaidGold}
        tagWidth={70}
      />
      <Et3Margin top={0} bottom={0} left={0} right={5} />
      <TagBadge
        tag={i18n.get("PLATINUM_TAG")}
        tagColor={
          isSubscribedPlatinum ? colors.all.mutedSteelBlue : colors.all.gray
        }
        isPaid={isPaidPlatinum}
        tagWidth={120}
      />

      <Et3Margin top={0} bottom={0} left={0} right={60} />

      <TagBadge
        isPaid={isPaidVIP}
        tag={i18n.get("VIP")}
        tagColor={isSubscribedVIP ? colors.all.vipGold : colors.all.gray}
        tagWidth={60}
      />
      <Et3Margin top={0} bottom={0} left={0} right={5} />
      <TagBadge
        isPaid={isPaidPlus}
        tag={i18n.get("PLUS")}
        tagColor={isSubscribedPlus ? colors.all.purple : colors.all.gray}
        tagWidth={80}
      />
      <Et3Margin top={0} bottom={0} left={0} right={5} />
      <TagBadge
        tag={i18n.get("KHATTABAT_TAG")}
        tagColor={
          isSubscribedAlkhattabat ? colors.all.brightCyan : colors.all.gray
        }
        isPaid={isPaidAlkhattabat}
        tagWidth={120}
      />

      <Et3Margin top={0} bottom={0} left={0} right={60} />

      <TagBadge
        isPaid={isPaidBoost}
        tag={i18n.get("BOOST")}
        tagColor={isSubscribedBoost ? colors.all.vipGold : colors.all.gray}
        tagWidth={80}
      />
      <Et3Margin top={0} bottom={0} left={0} right={5} />
      <TagBadge
        isPaid={isPaidRewind}
        tag={i18n.get("REWIND")}
        tagColor={isSubscribedRewind ? colors.all.purple : colors.all.gray}
        tagWidth={90}
      />
      <Et3Margin top={0} bottom={0} left={0} right={5} />
      <TagBadge
        isPaid={isPaidPower}
        tag={i18n.get("BUNDLE")}
        tagColor={isSubscribedPower ? colors.all.powerPurple : colors.all.gray}
        tagWidth={90}
      />
    </ET3Div>
  );
});

export default ActiveFeatureSets;
